// src/components/Backbtn.js
import React from "react";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = ({ tooltip }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => navigate(-1)}
      startIcon={<ArrowBackIcon />}
    >
      {tooltip || "Back"}
    </Button>
  );
};

export default BackButton;
